export const PRIVATE_DASHBOARD = 'private';
export const PUBLIC_DASHBOARD = 'public';
export const EMBEDDED_DASHBOARD = 'embedded';

export type DashboardType =
  | typeof PRIVATE_DASHBOARD
  | typeof PUBLIC_DASHBOARD
  | typeof EMBEDDED_DASHBOARD;
